var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:'mj-btn-' + _vm.type + ' btn-' + _vm.type,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }